import { Box, Divider } from '@mui/material';
import { FC } from 'react';
import {
    capitalizeWords,
    formatHippodromeName,
} from '../../../../../utils/format';
import { CourseFilter, Programme } from '../../../services/type';
import ChipResult from './ChipResult';

type Props = {
    filter: CourseFilter;
    setFilter: (value: CourseFilter) => void;
    programme: Programme;
};

const FiltersResult: FC<Props> = ({ filter, setFilter, programme }) => {
    const hasFilter =
        filter.discipline ||
        filter.montant ||
        filter.minParticipant ||
        filter.maxParticipant ||
        filter.reunion;

    let labelReunion = '';
    const reunion = programme.reunions.find(
        (r) => r.numOfficiel === filter.reunion
    );
    if (reunion) {
        labelReunion = `R${filter.reunion} - ${formatHippodromeName(reunion.hippodrome.libelleLong)}`;
    }

    return hasFilter ? (
        <Box display={'flex'} flexDirection={'column'} gap={1} width={'100%'}>
            <Box
                display={'flex'}
                flexDirection={'row'}
                flexWrap={'wrap'}
                width={'100%'}
                gap={2}
            >
                {filter.reunion && (
                    <ChipResult keyFilter="reunion" label={labelReunion} />
                )}
                {filter.discipline && (
                    <ChipResult
                        keyFilter="discipline"
                        label={capitalizeWords(filter.discipline)}
                    />
                )}
                {filter.minParticipant && (
                    <ChipResult
                        keyFilter="minParticipant"
                        label={`min ${String(filter.minParticipant)}`}
                    />
                )}
                {filter.maxParticipant && (
                    <ChipResult
                        keyFilter="maxParticipant"
                        label={`max ${String(filter.maxParticipant)}`}
                    />
                )}
            </Box>
            <Divider />
        </Box>
    ) : null;
};

export default FiltersResult;
